/**
 * Renvoi vers /login quand la session manque ou a expiré, puis retour à
 * l'adresse demandée après connexion (état d'historique `from`, jamais un
 * paramètre d'URL : rien de forgeable par un lien).
 */
export interface LoginRedirectState {
  /** Adresse interne demandée (chemin + requête + ancre). */
  from: string;
  /** La session vient d'expirer (sinon : simple visite sans session). */
  expired?: boolean;
}

export function loginRedirectState(
  loc: { pathname: string; search?: string; hash?: string },
  expired: boolean,
): LoginRedirectState {
  const from = `${loc.pathname}${loc.search ?? ''}${loc.hash ?? ''}`;
  return expired ? { from, expired: true } : { from };
}

/**
 * Adresse de retour après connexion : un chemin interne seulement (commence
 * par un seul « / »), jamais /login lui-même (boucle), sinon l'accueil.
 */
export function safeReturnPath(from: unknown): string {
  if (typeof from !== 'string' || !from.startsWith('/') || from.startsWith('//') || from.includes('\\')) return '/';
  if (/^\/login(?:[/?#]|$)/.test(from)) return '/';
  return from;
}
